import { Link } from 'react-router-dom';
import { companyStats } from '../../../mocks/ueber-uns';

export default function UeberUnsHero() {
  return (
    <section className="relative pt-20 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/68ba175f8363e75070e079659f839728.jpg"
          alt="IGM Team Über uns"
          className="w-full h-full object-cover object-top scale-110 blur-md"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0D2B4E]/92 via-[#0D2B4E]/75 to-[#0D2B4E]/30" />
      </div>

      <div className="relative w-full px-4 sm:px-6 lg:px-8 py-20 sm:py-28 max-w-7xl mx-auto">
        <nav className="flex items-center gap-2 text-sm text-white/60 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="hover:text-white transition-colors cursor-pointer">Startseite</Link>
          <div className="w-3 h-3 flex items-center justify-center">
            <i className="ri-arrow-right-s-line" />
          </div>
          <span className="text-white">Über uns</span>
        </nav>

        <div className="max-w-2xl">
          <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl p-8 sm:p-10">
            <span className="inline-block text-xs font-semibold tracking-widest text-white/80 uppercase mb-4">
              Wer wir sind
            </span>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-5">
              Erfahrung trifft Mut zur Selbständigkeit
            </h1>
            <p className="text-base sm:text-lg text-white/90 leading-relaxed max-w-xl mb-8">
              IGM Facility Service wurde 2021 gegründet — von Menschen, die jahrelange Berufserfahrung
              in Bau, Instandhaltung und Reinigung mitbrachten und den Schritt in die Selbständigkeit gewagt haben.
              Heute sind wir Ihr verlässlicher Partner rund ums Gebäude: von der Instandhaltung über Renovierung
              bis zur professionellen Reinigung — vieles leisten wir selbst, für Spezialaufgaben stehen uns
              starke Partnerunternehmen zur Seite.
            </p>
            <div className="flex flex-wrap gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center gap-2 bg-white text-[#0D2B4E] px-6 py-3 rounded-lg font-semibold hover:bg-gray-100 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-phone-line" />
                </div>
                Kostenlos anfragen
              </Link>
              <a
                href="#firmengeschichte"
                className="inline-flex items-center gap-2 border border-white/50 text-white px-6 py-3 rounded-lg font-semibold hover:bg-white/15 transition-colors cursor-pointer whitespace-nowrap"
              >
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-history-line" />
                </div>
                Unsere Geschichte
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Bar */}
      <div className="relative bg-[#f5f1eb] border-b border-[#e0d9cf]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-2 lg:grid-cols-4 divide-x divide-gray-100">
            {companyStats.map((stat) => (
              <div key={stat.label} className="px-4 sm:px-8 py-6 sm:py-8 text-center">
                <div className="text-2xl sm:text-3xl font-bold text-[#0D2B4E] mb-1">{stat.value}</div>
                <div className="text-xs sm:text-sm text-gray-500 font-medium">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
